import { render } from "./CreditNote.vue?vue&type=template&id=0917c72b&scoped=true"
import script from "./CreditNote.vue?vue&type=script&lang=js"
export * from "./CreditNote.vue?vue&type=script&lang=js"

import "./style.scss?vue&type=style&index=0&id=0917c72b&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0917c72b"]])

export default __exports__